import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import ReportsStandalone from 'components/folder/reports/reports-standalone'
import ListboxInput from "components/inputs/listbox"
import propertyReportService from "data/reports-property"
import notificationService from "data/notification"

export const AEExport: FC<RouteComponentProps> = (props) => {
  const [mode, setMode] = useState<"export_file" | "comparison_template">("export_file")

  const templateOptions = [
    {label: "Cash Flow Totals", value: 'cash_flow'},
    {label: "Rent Roll", value: 'rent_roll'},
    {label: "Line Items", value: 'line_item'},
  ]


  const submit = (body) => {
    if(body.hasUncalculated && mode==="comparison_template") {
      notificationService.notify({
        type: "danger",
        message: "All selected properties must be calculated to create a comparison template",
        dismiss: 3000
      })
    } else {
      const payload = {
        report: mode === "comparison_template" ?  "_comparison" : "_test_export",
        folderid: body.folderid,
        propertyid: body.propertyid,
        params: {  }
      }
      propertyReportService.propertyReport(payload)
      notificationService.notify({
        type: "info",
        message: "AE Export Initiated",
        dismiss: 3000
      })
    }
  }

  const params = () => {
    return (
      <div>
        <label>
          <input
            type="radio"
            onClick={(e) => setMode("export_file")}
            checked={mode === "export_file"} />
          AE Export File
        </label>
        <label>
          <input
            type="radio"
            onClick={(e) => setMode("comparison_template")}
            checked={mode === "comparison_template"} />
          Comparison Template (requires calculation)
        </label>
      </div>
    )
      /*<div>
        <label>Reconciliation Templates (Requires Calculation)</label>
        <ListboxInput
          field="templates"
          value={templates}
          persist={updateTemplates}
          multiple={true}
          options={templateOptions}
        />
      </div>*/
    }

  return (
    <div>
      <ReportsStandalone
        isBeta={true}
        runButtonText="Export"
        parameters={params}
        propertyFilter={(p) => p.type === 'Commercial'}
        submit={submit}
      />
    </div>
  )
}

export default AEExport
